<template>
   <el-dialog
        v-drag
        class="small-manage-driver-add-dialog"
        :title="'委派函上传'"
        :visible.sync="visible"
        width="400px"
        style="padding: 0 50px 50px 0"
        :before-close="close"
    >
        <el-form ref="formBox" class="form-box" label-width="100px" :model="form" :rules="rules">
            <el-form-item label="开始日期" prop="delegateStartTime">
                <el-date-picker
                    v-model="form.delegateStartTime"
                    type="date"
                    placeholder="开始日期"
                    :picker-options="pickerOptionsStart"
                    @change="startChange">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="delegateEndTime">
                <el-date-picker
                    v-model="form.delegateEndTime"
                    type="date"
                    placeholder="结束日期"
                    :picker-options="pickerOptionsEnd"
                    @change="endChange">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="confirm" type="primary" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import { pushDelegate } from '../../../../../../api/register/driver.js';
export default {
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            loading: false,
            rules: {
                delegateStartTime: [{
                    required: true, message: '不能为空', trigger: 'change'
                }],
                delegateEndTime: [{
                    required: true, message: '不能为空', trigger: 'change'
                }]
            },
            form: {
                delegateStartTime: '',
                delegateEndTime: ''
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() ||
                    time.getTime() >= new Date(new Date().toLocaleDateString()).getTime() + (365 * 3600 * 24 * 1000);
                }
            },
            pickerOptionsStart: { disabledDate: time => { return time.getTime() < new Date(new Date().toLocaleDateString()).getTime(); } }
        };
    },
    methods: {
        startChange(val) {
            this.pickerOptionsEnd = {
                disabledDate: time => {
                    if (!this.form.delegateStartTime) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    } else {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() ||
                            time.getTime() <= new Date(this.form.delegateStartTime).getTime() ||
                            time.getTime() >= new Date(new Date().toLocaleDateString()).getTime() + (365 * 3600 * 24 * 1000);
                    }
                }
            };
        },
        endChange() {
            this.pickerOptionsStart = {
                disabledDate: time => {
                    if (!this.form.delegateEndTime) {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
                    } else {
                        return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || time.getTime() >= new Date(this.form.delegateEndTime).getTime();
                    }
                }
            };
        },
        close() {
            this.$emit('update:visible', false);
        },
        confirm() {
            this.$refs.formBox.validate(res => {
                if (res) {
                    this.save();
                } else {
                    this.$message.warning('请填写完整信息！');
                }
            });
        },
        save() {
            this.loading = true;
            const relationIdList = this.selected.map(el => {
                return el.relationId;
            });
            const time = { ...this.form };
            time.delegateStartTime = dayjs(time.delegateStartTime).format('YYYY-MM-DD');
            time.delegateEndTime = dayjs(time.delegateEndTime).format('YYYY-MM-DD');
            const param = {
                relationIdList,
                ...time
            };
            pushDelegate(param).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('推送成功！');
                    this.$emit('update:visible', false);
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>